import { updateApplicationContainersGrouped } from "services/requests/v1/container";

import {
    SetRequestError,
    SetStateType,
    SubscribeContentType,
    UnsubscribeContentType,
} from "types/generic";
import { AppsContainerModel, AppsCreateMode } from "types/apps-container";
import { SaveButtonStatusType } from "types/apps-container";

type MakeCreateAppsGroupsModalFunctionsParams = {
    createMode: AppsCreateMode;
    containers: AppsContainerModel;
    inputText: string;
    createSubgroupTarget: string;
    translate: (id: string) => string;
    setInputText: SetStateType<string>;
    setSaveButtonStatus: SetStateType<SaveButtonStatusType>;
    setContainers: SetStateType<AppsContainerModel>;
    subscribeContent: SubscribeContentType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
    closeModalFn: () => void;
};

export const makeCreateAppsGroupsModalFunctions = ({
    createMode,
    containers,
    inputText,
    createSubgroupTarget,
    translate,
    setInputText,
    setError,
    setSaveButtonStatus,
    subscribeContent,
    unsubscribeContent,
    setContainers,
    closeModalFn,
}: MakeCreateAppsGroupsModalFunctionsParams) => {
    const defineTextBasedOnCreateMode = (intlIdBase: string) => {
        return translate(`${intlIdBase}_${createMode}`);
    };

    const handleInputChange = (newValue: string) => {
        const numberRegexp = /\d/;
        if (numberRegexp.test(newValue)) return;

        setInputText(newValue);
    };

    const updateDataOnRepo = async (newData: AppsContainerModel) => {
        const contentName = "create-group";

        try {
            subscribeContent(contentName);
            setSaveButtonStatus("disabled");

            const { data } = await updateApplicationContainersGrouped(newData);
            setContainers(data);

            unsubscribeContent(contentName, true);
            closeModalFn();
        } catch (error) {
            setError(contentName);
            setSaveButtonStatus("enabled");
        }
    };

    const handleCreateGroup = () => {
        const newData = { ...containers };
        newData[inputText] = [];

        updateDataOnRepo(newData);
    };

    const handleCreateSubGroup = () => {
        const newData = { ...containers };

        if (!newData[createSubgroupTarget]) return;

        newData[createSubgroupTarget].push({
            title: inputText,
            logo: "",
            containerOrder: newData[createSubgroupTarget].length,
            group: "",
            tags: "",
            url: "",
            colour: "",
            header: "",
            items: [],
            roles: [],
            visible: true,
            goAigua: false,
        } as any);

        updateDataOnRepo(newData);
    };

    const defineCreateStrategy = () => {
        return createMode === "group"
            ? handleCreateGroup
            : handleCreateSubGroup;
    };

    return {
        defineTextBasedOnCreateMode,
        handleInputChange,
        defineCreateStrategy,
    };
};
